/* global Modernizr */

import { Controller } from 'stimulus';

const isMobileNavigation = () => Modernizr.mq('(max-width: 991px)');
const isTouchDevice = () => Modernizr.touchevents;

const setTransform = (element, transform) => {
  element.style.webkitTransform = transform;
  element.style.msTransform = transform;
  element.style.transform = transform;
};

class Navigation extends Controller {
  static toggleDropdown(dropdown, state) {
    const dropdownId = dropdown.id;
    const toggle = document.querySelector(`[aria-controls="#${dropdownId}"]`);

    $(dropdown).toggleClass('is-open', state);
    toggle.setAttribute('aria-expanded', state);
  }

  static getLevelForElement(element, selector = 'data-level') {
    return parseInt(element.getAttribute(selector), 10);
  }

  static scrollToLevel(element, level) {
    const translate = `translateX(-${level * 100}%)`;
    setTransform(element, translate);
  }

  onDropdownOpen(e) {
    const dropdown = document.querySelector(e.target.getAttribute('aria-controls'));
    const isOpen = e.target.getAttribute('aria-expanded') === 'true';
    const toLevel = Navigation.getLevelForElement(e.target);

    if (!dropdown) {
      return true;
    }

    if (!isMobileNavigation() && isTouchDevice()) {
      e.preventDefault();
      return true;
    }

    if (!isMobileNavigation()) {
      return true;
    }

    if (isMobileNavigation() || isTouchDevice()) {
      e.preventDefault();
    }

    // Close all dropdowns on the same level to avoid overlap
    this.closeDropdownAfterLevel(toLevel - 1);

    Navigation.toggleDropdown(dropdown, !isOpen);
    Navigation.scrollToLevel(this.listTarget, toLevel);

    return true;
  }

  onBackClick(e) {
    e.preventDefault();

    const toLevel = Navigation.getLevelForElement(e.currentTarget, 'data-to-level');
    Navigation.scrollToLevel(this.listTarget, toLevel);
    this.closeDropdownAfterLevel(toLevel);
  }

  onDocumentClick(e) {
    if (isMobileNavigation()) {
      return;
    }

    if (!e.target.closest('.navigation__item')) {
      this.closeDropdownAfterLevel(0);
    }
  }

  closeDropdownAfterLevel(level) {
    this.dropdownTargets.forEach((dropdown) => {
      const dropdownLevel = Navigation.getLevelForElement(dropdown);

      if (dropdownLevel > level) {
        Navigation.toggleDropdown(dropdown, false);
      }
    });
  }
}

Navigation.targets = [
  'dropdown-toggle',
  'dropdown',
  'list',
];

export default Navigation;
